import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function KgController() {
  const { state } = useLocation();
  const [srcDoc, setSrcDoc] = useState("결제모듈 불러오는 중");
  useEffect(() => {
    if (!state?.htmlToShow) {
      return;
    }
    setSrcDoc(state.htmlToShow);
    //  iframe에서 오는 message 리슨
    // 메세지는 node메인서버/kgMob/ok 에서 정의됨
    window.addEventListener("message", receiveMessage, false);
    return () => {
      window.removeEventListener("message", receiveMessage, false);
    };
  }, []);

  const [detector, setDetector] = useState("");
  const naviagate = useNavigate();

  useEffect(() => {
    if (!detector) {
      return;
    }
    if (detector.includes("teeshotBackDetection")) {
      const regex = /teeshotBackDetection-(.*)/;
      const match = detector.match(regex);
      const backUrl = match?.[1];
      window.location.href = backUrl || process.env.REACT_APP_DOMAIN || "";
    }
  }, [detector]);

  function receiveMessage(event: any) {
    // if (event.origin !== "http://example.org:8080") return;
    setDetector(event.data || "");
    // ...
  }

  return (
    <Container className="page-pd-negative-all">
      <iframe onLoad={(o: any) => {}} id="foo1" width={"100%"} srcDoc={srcDoc} />
    </Container>
  );
}

const Container = styled.div`
  #foo1 {
    height: calc(100vh - 55px);
  }
`;
